<template>
  <transition
    name="fade-up"
    @after-enter="resetLock"
    @after-leave="resetLock"
  >
    <span v-show="!lock" class="text-rotator">{{ currentText }}</span>
  </transition>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lock: false,
      currentText: ''
    }
  },
  watch: {
    text () {
      this.lock = true
    }
  },
  created () {
    this.currentText = this.text
  },
  methods: {
    resetLock () {
      this.lock = false
      this.currentText = this.text
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-rotator {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/TextRotator.vue